module.exports = __webpack_public_path__ + "static/media/certFocusLogo.cf893336.png";